import { ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPES } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

const HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
export const helpCenterSettingsUnassignedTicketTypesConfigRoute: InvariantRoute = {
	exact: true,
	name: ROUTE_NAMES_HELP_CENTER_SETTINGS_REQUEST_TYPES,
	path: `${HELP_CENTER_SETTINGS_URL}/request-types/unassigned`,
};
